(() => {
  'use strict';

  const init = (root) => {
    if (!root || root.dataset.vsInitialized === 'true') return;
    root.dataset.vsInitialized = 'true';

    const form = root.querySelector('[data-vs-product-form]');
    const productEl = root.querySelector('[data-vs-product-json]');
    const rulesEl = root.querySelector('[data-vs-delivery-rules]');
    if (!form || !productEl) return;

    let product;
    let rules = [];
    try { product = JSON.parse(productEl.textContent); } catch (e) { return; }
    try { rules = JSON.parse(rulesEl?.textContent || '[]'); } catch (e) { rules = []; }

    const state = {
      variant: product.variants.find(v => String(v.id) === String(root.dataset.vsCurrentVariant)) ||
               product.variants.find(v => v.available) ||
               product.variants[0],
      galleryIndex: 0
    };

    const $ = (s) => root.querySelector(s);
    const $$ = (s) => [...root.querySelectorAll(s)];

    const formatMoney = (cents) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
          style: 'currency',
          currency: product.currency || 'INR',
          maximumFractionDigits: 2
        }).format(Number(cents) / 100);
      } catch (e) {
        return '₹' + (Number(cents) / 100).toFixed(2);
      }
    };

    const selectedOptions = () => {
      const values = [];
      $$('[data-vs-option-input]:checked').forEach(input => {
        values[Number(input.dataset.optionPosition) - 1] = input.value;
      });
      return values;
    };

    const findVariant = () => {
      const selected = selectedOptions();
      if (!selected.length) return state.variant;
      return product.variants.find(variant =>
        selected.every((value, i) => value === undefined || variant.options?.[i] === value)
      ) || null;
    };

    const mediaItems = () => $$('[data-vs-media]');
    const showGallery = (index) => {
      const items = mediaItems();
      if (!items.length) return;
      const nextIndex = ((index % items.length) + items.length) % items.length;
      state.galleryIndex = nextIndex;
      items.forEach((item, i) => {
        const active = i === nextIndex;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (!active) {
          const video = item.querySelector('video');
          if (video) { try { video.pause(); } catch (e) {} }
        }
      });
      $$('[data-vs-thumb]').forEach((thumb, i) => thumb.classList.toggle('is-active', i === nextIndex));
    };

    const updateVariantMedia = (variant) => {
      const id = variant?.featured_media?.id;
      if (!id) return;
      const items = mediaItems();
      const target = items.find(item => String(item.dataset.vsMediaId) === String(id));
      if (target) showGallery(items.indexOf(target));
    };

    const updateUI = (variant) => {
      const price = $('[data-vs-price]');
      const compare = $('[data-vs-compare]');
      const stock = $('[data-vs-stock]');
      const stockLabel = $('[data-vs-stock-label]');
      const skuTop = $('[data-vs-sku-top]');
      const skuDetail = $('[data-vs-detail-sku]');
      const availability = $('[data-vs-detail-availability]');
      const idInput = $('[data-vs-variant-id]');
      const add = $('[data-vs-add]');
      const addLabel = $('[data-vs-add-label]');
      const buy = $('[data-vs-buy-now]');

      if (!variant) {
        if (add) add.disabled = true;
        if (buy) buy.disabled = true;
        if (addLabel) addLabel.textContent = 'Unavailable';
        return;
      }

      state.variant = variant;
      if (idInput) idInput.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price);

      if (compare) {
        const hasCompare = variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price);
        compare.hidden = !hasCompare;
        compare.textContent = hasCompare ? formatMoney(variant.compare_at_price) : '';
      }

      if (stockLabel) stockLabel.textContent = variant.available ? 'In stock' : 'Out of stock';
      if (stock) stock.querySelector('.vs-stock__dot')?.classList.toggle('vs-stock__dot--off', !variant.available);
      if (skuTop) {
        skuTop.hidden = !variant.sku;
        skuTop.textContent = variant.sku ? `SKU: ${variant.sku}` : '';
      }
      if (skuDetail) skuDetail.textContent = variant.sku || '—';
      if (availability) availability.textContent = variant.available ? 'Available' : 'Unavailable';
      if (add) add.disabled = !variant.available;
      if (buy) buy.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';

      root.querySelectorAll('[data-vs-option-group]').forEach(group => {
        const checked = group.querySelector('[data-vs-option-input]:checked');
        const selectedLabel = group.querySelector('[data-vs-selected-option]');
        if (checked && selectedLabel) selectedLabel.textContent = checked.value;
      });

      updateVariantMedia(variant);
    };

    $$('[data-vs-option-input]').forEach(input => {
      input.addEventListener('change', () => updateUI(findVariant()));
    });

    $$('[data-vs-thumb]').forEach((thumb, i) => thumb.addEventListener('click', () => showGallery(i)));
    $('[data-vs-gallery-prev]')?.addEventListener('click', () => showGallery(state.galleryIndex - 1));
    $('[data-vs-gallery-next]')?.addEventListener('click', () => showGallery(state.galleryIndex + 1));

    const qty = $('[data-vs-quantity-input]');
    const setQty = value => { if (qty) qty.value = Math.max(1, parseInt(value, 10) || 1); };
    $('[data-vs-qty-minus]')?.addEventListener('click', () => setQty((parseInt(qty?.value, 10) || 1) - 1));
    $('[data-vs-qty-plus]')?.addEventListener('click', () => setQty((parseInt(qty?.value, 10) || 1) + 1));

    const addToCart = async (checkout) => {
      if (!state.variant?.available) return;
      const button = $('[data-vs-add]');
      if (button) button.classList.add('is-loading');

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({
            items: [{id: Number(state.variant.id), quantity: Math.max(1, parseInt(qty?.value,10) || 1)}]
          })
        });
        if (!response.ok) throw new Error('Cart add failed');
        const data = await response.json();

        document.dispatchEvent(new CustomEvent('vs:cart:updated', {bubbles:true, detail:data}));
        if (checkout) {
          window.location.href = '/checkout';
        } else {
          window.location.href = '/cart';
        }
      } catch (error) {
        console.error('VS product cart error:', error);
        const label = $('[data-vs-add-label]');
        if (label) {
          const old = label.textContent;
          label.textContent = 'Try again';
          setTimeout(() => label.textContent = old, 1600);
        }
      } finally {
        if (button) button.classList.remove('is-loading');
      }
    };

    form.addEventListener('submit', event => { event.preventDefault(); addToCart(false); });
    $('[data-vs-buy-now]')?.addEventListener('click', () => addToCart(true));

    /* Lightbox */
    const lightbox = $('[data-vs-lightbox]');
    const lightboxStage = $('[data-vs-lightbox-stage]');

    const openLightbox = () => {
      if (!lightbox || !lightboxStage) return;
      const active = mediaItems()[state.galleryIndex];
      if (!active) return;
      lightboxStage.innerHTML = '';
      const type = active.dataset.vsMediaType;

      if (type === 'image') {
        const image = active.querySelector('img');
        if (image) {
          const clone = image.cloneNode(true);
          clone.removeAttribute('loading');
          lightboxStage.appendChild(clone);
        }
      } else {
        const clone = active.cloneNode(true);
        clone.classList.add('is-active');
        lightboxStage.appendChild(clone);
      }

      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden','false');
      document.documentElement.style.overflow = 'hidden';
    };

    const closeLightbox = () => {
      if (!lightbox) return;
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden','true');
      lightboxStage.innerHTML = '';
      document.documentElement.style.overflow = '';
    };

    $('[data-vs-open-lightbox]')?.addEventListener('click', openLightbox);
    $('[data-vs-close-lightbox]')?.addEventListener('click', closeLightbox);
    $('[data-vs-lightbox-prev]')?.addEventListener('click', () => { showGallery(state.galleryIndex - 1); openLightbox(); });
    $('[data-vs-lightbox-next]')?.addEventListener('click', () => { showGallery(state.galleryIndex + 1); openLightbox(); });
    lightbox?.addEventListener('click', e => { if (e.target === lightbox) closeLightbox(); });

    document.addEventListener('keydown', e => {
      if (!lightbox?.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') { showGallery(state.galleryIndex - 1); openLightbox(); }
      if (e.key === 'ArrowRight') { showGallery(state.galleryIndex + 1); openLightbox(); }
    });

    /* Touch gallery */
    const stage = $('[data-vs-media-stage]');
    let touchStartX = null;
    stage?.addEventListener('touchstart', e => { touchStartX = e.changedTouches[0].clientX; }, {passive:true});
    stage?.addEventListener('touchend', e => {
      if (touchStartX === null) return;
      const delta = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(delta) > 45) showGallery(delta < 0 ? state.galleryIndex + 1 : state.galleryIndex - 1);
      touchStartX = null;
    }, {passive:true});

    /* PIN rules */
    const pin = $('[data-vs-pincode]');
    const pinButton = $('[data-vs-check-pin]');
    const pinMessage = $('[data-vs-pin-message]');

    const checkPin = () => {
      if (!pin || !pinMessage) return;
      const value = pin.value.trim().replace(/\s+/g,'');
      pinMessage.className = 'vs-pincode__message';

      if (!/^\d{5,10}$/.test(value)) {
        pinMessage.textContent = 'Please enter a valid PIN code.';
        pinMessage.classList.add('is-error');
        return;
      }

      if (!rules.length) {
        pinMessage.textContent = 'Delivery estimate is not configured yet.';
        pinMessage.classList.add('is-error');
        return;
      }

      const rule = rules.find(item =>
        (item.prefixes || []).some(prefix => {
          const p = String(prefix || '').trim();
          return p && value.startsWith(p);
        })
      );

      if (!rule) {
        pinMessage.textContent = 'Delivery estimate is not available for this PIN yet.';
        pinMessage.classList.add('is-error');
        return;
      }

      let message = String(rule.message || 'Estimated delivery in {min}-{max} business days.');
      message = message.replace(/\{min\}/g, Number(rule.minDays)).replace(/\{max\}/g, Number(rule.maxDays));
      pinMessage.textContent = message;
      pinMessage.classList.add('is-success');
    };

    pinButton?.addEventListener('click', checkPin);
    pin?.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); checkPin(); } });

    const items = mediaItems();
    showGallery(Math.max(0, items.findIndex(item => item.classList.contains('is-active'))));
    updateUI(state.variant);
  };

  const boot = () => document.querySelectorAll('[data-vs-product-root]').forEach(init);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll?.('[data-vs-product-root]').forEach(init);
  });
})();


/* ============================================================
   VS V4 — AUTOMATIC PIN + THUMBNAIL CAROUSEL + TABS
   Add-on only; existing product actions remain intact.
   ============================================================ */
(() => {
  'use strict';

  /* ---------- Automatic Indian PIN estimate ---------- */
  const vsAutoPinRange = (pin) => {
    const first = Number(String(pin).charAt(0));

    if ([1, 2, 3, 4].includes(first)) return [2, 5];
    if ([5, 6].includes(first)) return [3, 6];
    if ([7, 8].includes(first)) return [3, 6];
    if (first === 9) return [4, 7];

    return [3, 6];
  };

  const initAutoPin = (root) => {
    const pin = root.querySelector('[data-vs-pincode]');
    const button = root.querySelector('[data-vs-check-pin]');
    const message = root.querySelector('[data-vs-pin-message]');

    if (!pin || !button || !message || button.dataset.vsAutoPinReady === 'true') return;
    button.dataset.vsAutoPinReady = 'true';

    const run = () => {
      const value = pin.value.trim().replace(/\D/g, '');

      message.className = 'vs-pincode__message';

      if (!/^[1-9]\d{5}$/.test(value)) {
        message.textContent = 'Please enter a valid 6-digit Indian PIN code.';
        message.classList.add('is-error');
        return;
      }

      const [min, max] = vsAutoPinRange(value);
      message.textContent = `Estimated delivery in ${min}-${max} business days.`;
      message.classList.add('is-success');
    };

    button.addEventListener('click', run, false);
    pin.addEventListener('keydown', event => {
      if (event.key === 'Enter') {
        event.preventDefault();
        run();
      }
    });
  };

  /* ---------- Thumbnail carousel arrows ---------- */
  const initThumbCarousel = (root) => {
    const track = root.querySelector('[data-vs-thumbs]');
    const prev = root.querySelector('[data-vs-thumb-prev]');
    const next = root.querySelector('[data-vs-thumb-next]');

    if (!track || !prev || !next || track.dataset.vsThumbCarouselReady === 'true') return;
    track.dataset.vsThumbCarouselReady = 'true';

    const update = () => {
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    };

    const slide = direction => {
      const item = track.querySelector('[data-vs-thumb]');
      const amount = item
        ? (item.getBoundingClientRect().width + 10) * 2
        : track.clientWidth * 0.7;

      track.scrollBy({
        left: direction * amount,
        behavior: 'smooth'
      });
    };

    prev.addEventListener('click', () => slide(-1));
    next.addEventListener('click', () => slide(1));
    track.addEventListener('scroll', update, { passive:true });
    window.addEventListener('resize', update);

    setTimeout(update, 100);
  };

  /* ---------- Product information tabs ---------- */
  const initTabs = (root) => {
    const tabs = [...root.querySelectorAll('[data-vs-tabs] [data-vs-tab]')];
    const panels = [...root.querySelectorAll('[data-vs-tabs] [data-vs-panel]')];
    const tabsWrap = root.querySelector('[data-vs-tabs] .vs-tabs');

    if (!tabs.length || !panels.length || !tabsWrap || root.dataset.vsTabsV4 === 'true') return;
    root.dataset.vsTabsV4 = 'true';

    const activate = (name, center = true) => {
      tabs.forEach(tab => {
        const active = tab.dataset.vsTab === name;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      panels.forEach(panel => {
        const active = panel.dataset.vsPanel === name;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });

      if (center) {
        const activeTab = tabs.find(tab => tab.dataset.vsTab === name);
        activeTab?.scrollIntoView({
          behavior:'smooth',
          block:'nearest',
          inline:'center'
        });
      }
    };

    tabs.forEach(tab => {
      tab.addEventListener('click', () => activate(tab.dataset.vsTab, true));
    });

    /* Move specification tables out of Description when they are embedded there. */
    const description = root.querySelector('[data-vs-description]');
    const specifications = root.querySelector('[data-vs-specifications]');

    if (description && specifications) {
      const tables = [...description.querySelectorAll('table')];
      const specTables = tables.filter(table => {
        const text = (table.textContent || '').toLowerCase();
        return /specification|processor|display|memory|storage|ram|ssd|graphics|operating system|battery|screen|resolution/.test(text);
      });

      if (specTables.length) {
        specifications.querySelector('.vs-spec-empty')?.remove();
        specTables.forEach(table => specifications.appendChild(table));
      }
    }

    const active = tabs.find(tab => tab.classList.contains('is-active')) || tabs[0];
    activate(active.dataset.vsTab, false);
  };

  const boot = () => {
    document.querySelectorAll('[data-vs-product-root]').forEach(root => {
      initAutoPin(root);
      initThumbCarousel(root);
      initTabs(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll?.('[data-vs-product-root]').forEach(root => {
      initAutoPin(root);
      initThumbCarousel(root);
      initTabs(root);
    });
  });
})();
